"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var _GoodFiltersAndPage = _interopRequireDefault(require("./GoodFiltersAndPage"));

var _GoodSubTypes = _interopRequireDefault(require("./GoodSubTypes"));

var _IndustryOptions = _interopRequireDefault(require("../constants/IndustryOptions"));

var _TemplatePurposeOptions = _interopRequireDefault(require("../constants/TemplatePurposeOptions"));

var _PageLayoutOptions = _interopRequireDefault(require("../constants/PageLayoutOptions"));

var _ProviderOptions = _interopRequireDefault(require("../constants/ProviderOptions"));

var _SortOptions = _interopRequireDefault(require("./SortOptions"));

var _Limits = _interopRequireDefault(require("./Limits"));

var _Immutable$Map;

var _default = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.SORT_BY, _SortOptions.default.MOST_DOWNLOADED), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.INDUSTRY, _IndustryOptions.default.ALL), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.LIMIT, _Limits.default.SMALL), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.PAGE, 0), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.PAGE_LAYOUT, _PageLayoutOptions.default.ALL), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.CODING_TYPE, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.PRICE, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.SUB_TYPE, _GoodSubTypes.default.ALL), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _TemplatePurposeOptions.default.ALL), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.FEATURES, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.CHILD_TYPES, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.SEARCH_TERM, ''), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.MODULE_PURPOSE, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY, _immutable.default.List.of()), (0, _defineProperty2.default)(_Immutable$Map, _GoodFiltersAndPage.default.PROVIDER, _ProviderOptions.default.ALL), _Immutable$Map));

exports.default = _default;
module.exports = exports.default;